export const fontSizes = {
  xs: '0.625rem',
  sm: '0.75rem',
  md: '1rem',
  lg: '1.125rem',
  xl: '1.25rem',
  '2xl': '1.5rem',
  '3xl': '1.75rem',
  '4xl': '2.25rem',
  '5xl': '3rem',
  '6xl': '3.25rem',
  '7xl': '4.25rem',
  '8xl': '6rem',
  '9xl': '8rem',
};
